import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Chip,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { BRAND } from '../../theme/brandTheme';
import { DECISION_OPTIONS } from './ReportMetadataPanel';

const STATUS_COLORS = {
  Canlı: 'success',
  Taslak: 'warning',
  Durduruldu: 'default',
};

const RESULT_COLORS = {
  Kazandı: 'success',
  Kaybetti: 'error',
  Etkisiz: 'default',
};

/** Last N reports mini list for statistics page */
const RecentReportsList = ({ reports = [] }) => {
  if (!reports.length) return null;

  const decisionLabel = (value) =>
    DECISION_OPTIONS.find((o) => o.value === value)?.label || 'Beklemede';

  return (
    <Card sx={{ boxShadow: '0 2px 10px rgba(0,0,0,0.08)', mt: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <HistoryIcon sx={{ color: BRAND.purple }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Son Raporlar
          </Typography>
        </Box>
        <List disablePadding dense>
          {reports.map((report) => (
            <ListItem key={report.id} disablePadding divider>
              <ListItemButton
                component={RouterLink}
                to={`/dashboard/reports/${report.id}`}
                sx={{ py: 1.25 }}
              >
                <ListItemText
                  primary={
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {report.name}
                    </Typography>
                  }
                  secondary={
                    <Box component="span" sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
                      {report.brand && (
                        <Typography component="span" variant="caption" color="text.secondary">
                          {report.brand}
                        </Typography>
                      )}
                      {report.status && (
                        <Chip
                          label={report.status}
                          size="small"
                          color={STATUS_COLORS[report.status] || 'default'}
                          sx={{ height: 20, fontSize: 11 }}
                        />
                      )}
                      {report.resultStatus && (
                        <Chip
                          label={report.resultStatus}
                          size="small"
                          color={RESULT_COLORS[report.resultStatus] || 'default'}
                          variant="outlined"
                          sx={{ height: 20, fontSize: 11 }}
                        />
                      )}
                      <Chip
                        label={decisionLabel(report.decision)}
                        size="small"
                        variant="outlined"
                        sx={{ height: 20, fontSize: 11 }}
                      />
                    </Box>
                  }
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default RecentReportsList;
